import React, { useState, useEffect } from 'react';
import { Modal, Button, Icon, Progress, Header } from 'semantic-ui-react';

const translations = {
  en: {
    titleExpired: 'Session Expired',
    titleWarning: 'Session About to Expire',
    headerExpired: 'Your session has expired',
    bodyExpired1: "For security reasons, you've been logged out after 2 hours of inactivity.",
    bodyExpired2: 'Please log in again to continue working on your circuit.',
    headerWarning: 'Your session will expire in',
    minute: 'minute',
    minutes: 'minutes',
    bodyWarning1: 'You will be automatically logged out due to inactivity.',
    bodyWarning2: 'Would you like to stay logged in?',
    btnLogin: 'Log In Again',
    btnLogout: 'Log Out',
    btnStay: 'Stay Logged In'
  },
  ar: {
    titleExpired: 'انتهت الجلسة',
    titleWarning: 'الجلسة على وشك الانتهاء',
    headerExpired: 'لقد انتهت جلستك',
    bodyExpired1: 'لأسباب أمنية، تم تسجيل خروجك بعد ساعتين من عدم النشاط.',
    bodyExpired2: 'يرجى تسجيل الدخول مرة أخرى لمتابعة العمل على دائرتك.',
    headerWarning: 'ستنتهي جلستك خلال',
    minute: 'دقيقة',
    minutes: 'دقائق',
    bodyWarning1: 'سيتم تسجيل خروجك تلقائيًا بسبب عدم النشاط.',
    bodyWarning2: 'هل تود البقاء مسجلاً؟',
    btnLogin: 'تسجيل الدخول مجدداً',
    btnLogout: 'تسجيل الخروج',
    btnStay: 'البقاء مسجلاً'
  },
  tr: {
    titleExpired: 'Oturum Süresi Doldu',
    titleWarning: 'Oturum Süresi Dolmak Üzere',
    headerExpired: 'Oturumunuzun süresi doldu',
    bodyExpired1: 'Güvenlik nedenleriyle, 2 saatlik hareketsizlikten sonra oturumunuz kapatıldı.',
    bodyExpired2: 'Devreniz üzerinde çalışmaya devam etmek için lütfen tekrar giriş yapın.',
    headerWarning: 'Oturumunuz şu süre içinde sona erecek:',
    minute: 'dakika',
    minutes: 'dakika',
    bodyWarning1: 'Hareketsizlik nedeniyle oturumunuz otomatik olarak kapatılacak.',
    bodyWarning2: 'Oturumunuzu açık tutmak ister misiniz?',
    btnLogin: 'Tekrar Giriş Yap',
    btnLogout: 'Çıkış Yap',
    btnStay: 'Oturumu Açık Tut'
  },
  de: {
    titleExpired: 'Sitzung abgelaufen',
    titleWarning: 'Sitzung läuft bald ab',
    headerExpired: 'Ihre Sitzung ist abgelaufen',
    bodyExpired1: 'Aus Sicherheitsgründen wurden Sie nach 2 Stunden Inaktivität abgemeldet.',
    bodyExpired2: 'Bitte melden Sie sich erneut an, um weiter an Ihrer Schaltung zu arbeiten.',
    headerWarning: 'Ihre Sitzung endet in',
    minute: 'Minute',
    minutes: 'Minuten',
    bodyWarning1: 'Sie werden aufgrund von Inaktivität automatisch abgemeldet.',
    bodyWarning2: 'Möchten Sie angemeldet bleiben?',
    btnLogin: 'Erneut anmelden',
    btnLogout: 'Abmelden',
    btnStay: 'Angemeldet bleiben'
  },
  es: {
    titleExpired: 'Sesión Caducada',
    titleWarning: 'La sesión está a punto de caducar',
    headerExpired: 'Tu sesión ha caducado',
    bodyExpired1: 'Por razones de seguridad, se ha cerrado tu sesión tras 2 horas de inactividad.',
    bodyExpired2: 'Por favor, inicia sesión de nuevo para continuar trabajando en tu circuito.',
    headerWarning: 'Tu sesión caducará en',
    minute: 'minuto',
    minutes: 'minutos',
    bodyWarning1: 'Se cerrará tu sesión automáticamente debido a la inactividad.',
    bodyWarning2: '¿Te gustaría mantener la sesión iniciada?',
    btnLogin: 'Iniciar Sesión de Nuevo',
    btnLogout: 'Cerrar Sesión',
    btnStay: 'Mantener Sesión'
  },
  fr: {
    titleExpired: 'Session expirée',
    titleWarning: 'La session est sur le point d\'expirer',
    headerExpired: 'Votre session a expiré',
    bodyExpired1: 'Pour des raisons de sécurité, vous avez été déconnecté après 2 heures d\'inactivité.',
    bodyExpired2: 'Veuillez vous reconnecter pour continuer à travailler sur votre circuit.',
    headerWarning: 'Votre session expirera dans',
    minute: 'minute',
    minutes: 'minutes',
    bodyWarning1: 'Vous serez automatiquement déconnecté en raison de l\'inactivité.',
    bodyWarning2: 'Souhaitez-vous rester connecté ?',
    btnLogin: 'Se reconnecter',
    btnLogout: 'Se déconnecter',
    btnStay: 'Rester connecté'
  },
  mx: {
    titleExpired: 'Sesión Caducada',
    titleWarning: 'La sesión está a punto de caducar',
    headerExpired: 'Tu sesión ha caducado',
    bodyExpired1: 'Por razones de seguridad, se ha cerrado tu sesión tras 2 horas de inactividad.',
    bodyExpired2: 'Por favor, inicia sesión de nuevo para continuar trabajando en tu circuito.',
    headerWarning: 'Tu sesión caducará en',
    minute: 'minuto',
    minutes: 'minutos',
    bodyWarning1: 'Se cerrará tu sesión automáticamente debido a la inactividad.',
    bodyWarning2: '¿Te gustaría mantener la sesión iniciada?',
    btnLogin: 'Iniciar Sesión de Nuevo',
    btnLogout: 'Cerrar Sesión',
    btnStay: 'Mantener Sesión'
  },
  th: {
    titleExpired: 'เซสชันหมดอายุ',
    titleWarning: 'เซสชันกำลังจะหมดอายุ',
    headerExpired: 'เซสชันของคุณหมดอายุแล้ว',
    bodyExpired1: 'เพื่อความปลอดภัย คุณถูกออกจากระบบหลังจากไม่มีการใช้งานเป็นเวลา 2 ชั่วโมง',
    bodyExpired2: 'กรุณาเข้าสู่ระบบอีกครั้งเพื่อทำงานต่อ',
    headerWarning: 'เซสชันของคุณจะหมดอายุใน',
    minute: 'นาที',
    minutes: 'นาที',
    bodyWarning1: 'คุณจะถูกออกจากระบบโดยอัตโนมัติเนื่องจากไม่มีการใช้งาน',
    bodyWarning2: 'คุณต้องการอยู่ในระบบต่อหรือไม่?',
    btnLogin: 'เข้าสู่ระบบอีกครั้ง',
    btnLogout: 'ออกจากระบบ',
    btnStay: 'อยู่ในระบบต่อ'
  },
  ro: {
    titleExpired: 'Sesiune expirată',
    titleWarning: 'Sesiunea este pe cale să expire',
    headerExpired: 'Sesiunea ta a expirat',
    bodyExpired1: 'Din motive de securitate, ați fost deconectat după 2 ore de inactivitate.',
    bodyExpired2: 'Vă rugăm să vă autentificați din nou pentru a continua lucrul la circuit.',
    headerWarning: 'Sesiunea ta va expira în',
    minute: 'minut',
    minutes: 'minute',
    bodyWarning1: 'Veți fi deconectat automat din cauza inactivității.',
    bodyWarning2: 'Doriți să rămâneți conectat?',
    btnLogin: 'Autentificare din nou',
    btnLogout: 'Deconectare',
    btnStay: 'Rămâi conectat'
  },
  my: {
    titleExpired: 'Sesi Tamat',
    titleWarning: 'Sesi Hampir Tamat',
    headerExpired: 'Sesi anda telah tamat',
    bodyExpired1: 'Atas sebab keselamatan, anda telah dilog keluar selepas 2 jam tidak aktif.',
    bodyExpired2: 'Sila log masuk semula untuk meneruskan kerja pada litar anda.',
    headerWarning: 'Sesi anda akan tamat dalam',
    minute: 'minit',
    minutes: 'minit',
    bodyWarning1: 'Anda akan dilog keluar secara automatik kerana tidak aktif.',
    bodyWarning2: 'Adakah anda mahu kekal log masuk?',
    btnLogin: 'Log Masuk Semula',
    btnLogout: 'Log Keluar',
    btnStay: 'Kekal Log Masuk'
  },
  bg: {
    titleExpired: 'Сесията изтече',
    titleWarning: 'Сесията е на път да изтече',
    headerExpired: 'Вашата сесия изтече',
    bodyExpired1: 'От съображения за сигурност бяхте отписани след 2 часа бездействие.',
    bodyExpired2: 'Моля, влезте отново, за да продължите работата по вашата верига.',
    headerWarning: 'Вашата сесия ще изтече след',
    minute: 'минута',
    minutes: 'минути',
    bodyWarning1: 'Ще бъдете автоматично отписани поради бездействие.',
    bodyWarning2: 'Искате ли да останете вписани?',
    btnLogin: 'Влезте отново',
    btnLogout: 'Изход',
    btnStay: 'Остани вписан'
  },
  id: {
    titleExpired: 'Sesi Berakhir',
    titleWarning: 'Sesi Akan Segera Berakhir',
    headerExpired: 'Sesi Anda telah berakhir',
    bodyExpired1: 'Demi keamanan, Anda telah dikeluarkan setelah 2 jam tidak aktif.',
    bodyExpired2: 'Silakan masuk lagi untuk melanjutkan pekerjaan pada sirkuit Anda.',
    headerWarning: 'Sesi Anda akan berakhir dalam',
    minute: 'menit',
    minutes: 'menit',
    bodyWarning1: 'Anda akan dikeluarkan secara otomatis karena tidak aktif.',
    bodyWarning2: 'Apakah Anda ingin tetap masuk?',
    btnLogin: 'Masuk Lagi',
    btnLogout: 'Keluar',
    btnStay: 'Tetap Masuk'
  },
  zh: {
    titleExpired: '会话已过期',
    titleWarning: '会话即将过期',
    headerExpired: '您的会话已过期',
    bodyExpired1: '出于安全原因，您在 2 小时未活动后已注销。',
    bodyExpired2: '请重新登录以继续处理您的电路。',
    headerWarning: '您的会话将在...后过期',
    minute: '分钟',
    minutes: '分钟',
    bodyWarning1: '由于不活动，您将自动注销。',
    bodyWarning2: '您想保持登录状态吗？',
    btnLogin: '再次登录',
    btnLogout: '注销',
    btnStay: '保持登录'
  }
};

/**
 * SessionWarningModal
 *
 * Displays a warning when user session is about to expire.
 * Provides options to extend session or logout.
 */
const SessionWarningModal = ({
  open,
  minutesLeft,
  onExtend,
  onLogout,
  isExpired = false,
  current_locale = 'en'
}) => {
  const [extending, setExtending] = useState(false);

  // Get translations based on current locale, fallback to english
  // Handles cases where locale might be 'en-US' or just 'en', or unsupported
  const getTranslations = (locale) => {
    // Direct match
    if (translations[locale]) return translations[locale];

    // Check for short code (e.g. 'en-US' -> 'en')
    const shortCode = locale ? locale.split('-')[0] : 'en';
    if (translations[shortCode]) return translations[shortCode];

    // Default to English
    return translations['en'];
  };

  const t = getTranslations(current_locale);

  const handleExtend = async () => {
    setExtending(true);
    const success = await onExtend();
    setExtending(false);

    if (!success) {
      // If extension failed, session likely already expired
      window.location.reload();
    }
  };

  const handleLogout = () => {
    onLogout();
    window.open('/users/sign_in', '_blank');
  };

  // Calculate progress percentage (5 minutes = 100%, 0 minutes = 0%)
  const progressPercent = isExpired ? 0 : Math.max(0, (minutesLeft / 5) * 100);

  // Determine color based on time left
  const getProgressColor = () => {
    if (isExpired) return 'red';
    if (minutesLeft <= 1) return 'red';
    if (minutesLeft <= 3) return 'orange';
    return 'yellow';
  };

  return (
    <Modal
      open={open}
      size="small"
      dimmer="blurring"
      closeOnEscape={false}
      closeOnDimmerClick={false}
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <Modal.Header>
        <Icon name={isExpired ? 'exclamation triangle' : 'clock outline'} />
        {isExpired ? t.titleExpired : t.titleWarning}
      </Modal.Header>

      <Modal.Content>
        {isExpired ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <Icon name="exclamation triangle" size="huge" color="red" />
            <Header as="h3" style={{ marginTop: '20px' }}>
              {t.headerExpired}
            </Header>
            <p style={{ fontSize: '16px', marginTop: '15px' }}>
              {t.bodyExpired1}
            </p>
            <p style={{ fontSize: '14px', color: '#666' }}>
              {t.bodyExpired2}
            </p>
          </div>
        ) : (
          <>
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <Icon name="clock outline" size="huge" color={getProgressColor()} />
              <Header as="h3" style={{ marginTop: '20px' }}>
                {t.headerWarning} {minutesLeft} {minutesLeft === 1 ? t.minute : t.minutes}
              </Header>
              <p style={{ fontSize: '16px', marginTop: '15px' }}>
                {t.bodyWarning1}
              </p>
              <p style={{ fontSize: '14px', color: '#666' }}>
                {t.bodyWarning2}
              </p>
            </div>

            <div style={{ marginTop: '20px' }}>
              <Progress
                percent={progressPercent}
                color={getProgressColor()}
                size="medium"
                indicating={!isExpired}
              />
            </div>
          </>
        )}
      </Modal.Content>

      <Modal.Actions>
        {isExpired ? (
          <Button
            color="blue"
            onClick={handleLogout}
            fluid
            size="large"
          >
            <Icon name="sign in" />
            {t.btnLogin}
          </Button>
        ) : (
          <>
            <Button
              onClick={handleLogout}
              basic
            >
              {t.btnLogout}
            </Button>
            <Button
              color="green"
              onClick={handleExtend}
              loading={extending}
              disabled={extending}
              primary
            >
              <Icon name="refresh" />
              {t.btnStay}
            </Button>
          </>
        )}
      </Modal.Actions>
    </Modal>
  );
};

export default SessionWarningModal;
